import { useLocation } from "react-router-dom";
import ShopHeader from "@/components/shop/ShopHeader";

export default function FarmSkeleton() {
    const location = useLocation();
    const isEdit =
        location.pathname.includes("/edit") ||
        location.pathname.includes("/new");

    return (
        <div className="bg-cream dark:bg-dark min-h-screen pb-8 transition-colors duration-300">
            {/* Mobile Header */}
            <div className="md:hidden sticky top-0 z-40 bg-surface/90 dark:bg-dark-2/90 backdrop-blur-md border-b border-gold/10">
                <ShopHeader
                    title={isEdit ? "Loading..." : "Kelola Farm"}
                    showBack
                />
            </div>

            {/* Desktop Header */}
            <div className="hidden md:block mt-4 pt-8 sticky top-22 z-30 bg-surface/50 dark:bg-dark-2/80 backdrop-blur-md border-b border-gold/10">
                <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="h-8 w-8 bg-black/5 dark:bg-white/5 rounded-full animate-pulse" />
                        <div className="h-6 w-32 bg-black/5 dark:bg-white/5 rounded animate-pulse" />
                    </div>
                    {isEdit ? (
                        <div className="h-10 w-32 bg-black/5 dark:bg-white/5 rounded-xl animate-pulse" />
                    ) : (
                        <div className="h-10 w-40 bg-black/5 dark:bg-white/5 rounded-xl animate-pulse" />
                    )}
                </div>
            </div>

            <main className="max-w-7xl mx-auto w-full px-4 md:px-6 py-6 flex flex-col gap-6">
                {isEdit ? (
                    <div className="flex flex-col lg:grid lg:grid-cols-12 gap-6 md:gap-8">
                        {/* Left Column Skeleton */}
                        <div className="lg:col-span-8 space-y-8">
                            <div className="h-100 bg-white dark:bg-dark-2 border border-gold/10 rounded-3xl animate-pulse" />
                            <div className="h-75 bg-white dark:bg-dark-2 border border-gold/10 rounded-3xl animate-pulse" />
                            <div className="h-125 bg-white dark:bg-dark-2 border border-gold/10 rounded-3xl animate-pulse" />
                        </div>
                        {/* Right Column Skeleton */}
                        <div className="lg:col-span-4 space-y-8">
                            <div className="h-62.5 bg-white dark:bg-dark-2 border border-gold/10 rounded-3xl animate-pulse" />
                            <div className="h-75 bg-white dark:bg-dark-2 border border-gold/10 rounded-3xl animate-pulse" />
                            <div className="h-50 bg-white dark:bg-dark-2 border border-gold/10 rounded-3xl animate-pulse" />
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="h-16 w-full bg-gold/5 dark:bg-gold/10 border border-gold/20 rounded-2xl animate-pulse" />
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                            {[1, 2, 3].map((i) => (
                                <div
                                    key={i}
                                    className="bg-white dark:bg-dark-2 rounded-2xl border border-gold/10 overflow-hidden flex flex-col">
                                    <div className="w-full aspect-video bg-black/5 dark:bg-white/5 animate-pulse" />
                                    <div className="p-4 flex flex-col gap-3">
                                        <div className="flex items-center justify-between mb-1">
                                            <div className="h-4 w-1/2 bg-black/5 dark:bg-white/5 rounded animate-pulse" />
                                            <div className="h-4 w-1/4 bg-black/5 dark:bg-white/5 rounded animate-pulse" />
                                        </div>
                                        <div className="h-3 w-1/3 bg-black/5 dark:bg-white/5 rounded animate-pulse mb-3" />

                                        <div className="grid grid-cols-5 gap-2 pt-3 border-t border-gold/10">
                                            <div className="col-span-2 h-8 bg-black/5 dark:bg-white/5 rounded-lg animate-pulse" />
                                            <div className="col-span-2 h-8 bg-black/5 dark:bg-white/5 rounded-lg animate-pulse" />
                                            <div className="col-span-1 h-8 bg-black/5 dark:bg-white/5 rounded-lg animate-pulse" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </main>
        </div>
    );
}
